import 'svelte/internal/disclose-version';

Voice[$.FILENAME] = 'src/web/concepts/voice.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations($.from_html(`<p> </p>`), Voice[$.FILENAME], [[54, 15]]);

var root_1 = $.add_locations(
	$.from_html(
		`
      <audio controls="" class="w-full"></audio>
      <button class="btn self-start">Send it and pick a time</button>
    `,
		1
	),
	Voice[$.FILENAME],
	[[56, 6], [57, 6]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">Don't write. Just tell us, in 60 seconds.</h1>
    <div class="flex items-center gap-6">
      <button> </button>
      <div class="flex flex-col gap-2 flex-1">
        <div class="h-2 bg-ink/15"><div class="h-full bg-ink transition-all"></div></div>
        <span class="tabular-nums opacity-60"> </span>
      </div>
    </div>
    <!>
    <!>
  `,
		1
	),
	Voice[$.FILENAME],
	[
		[44, 4],
		[45, 4, [[46, 6], [49, 6, [[50, 8, [[50, 35]]], [51, 8]]]]]
	]
);

var root_3 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">We'll listen before we meet.</h1>
    <!>
  `,
		1
	),
	Voice[$.FILENAME],
	[[60, 4]]
);

var root_4 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-3xl flex flex-col gap-8">
  <!>
</div>`,
		1
	),
	Voice[$.FILENAME],
	[[42, 0]]
);

function Voice($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Voice);

	let recorder = null;
	let recording = $.tag($.state(false), 'recording');
	let seconds = $.tag($.state(0), 'seconds');
	let url = $.tag($.state(null), 'url');
	let error = $.tag($.state(""), 'error');
	let ready = $.tag($.state(false), 'ready');
	let timer = 0;

	const start = async () => {
		$.set(error, "");

		try {
			const stream = (await $.track_reactivity_loss(navigator.mediaDevices.getUserMedia({ audio: true })))();
			const chunks = [];

			recorder = new MediaRecorder(stream);
			recorder.ondataavailable = (e) => chunks.push(e.data);

			recorder.onstop = () => {
				stream.getTracks().forEach((t) => t.stop());
				$.set(url, URL.createObjectURL(new Blob(chunks, { type: recorder?.mimeType })), true);
			};

			recorder.start();
			$.set(recording, true);
			$.set(seconds, 0);

			timer = window.setInterval(
				() => {
					$.update(seconds);

					if ($.get(seconds) >= 60) stop();
				},
				1000
			);
		} catch {
			$.set(error, "We couldn't access your microphone.");
		}
	};

	const stop = () => {
		clearInterval(timer);
		recorder?.stop();
		$.set(recording, false);
	};

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_4();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent_2 = ($$anchor) => {
			var fragment_1 = root_2();
			var div_1 = $.sibling($.first_child(fragment_1), 3);
			var button = $.sibling($.child(div_1));
			var text = $.only_child(button, true);
			var div_2 = $.sibling(button, 2);
			var div_3 = $.sibling($.child(div_2));
			var div_4 = $.child(div_3);
			let styles;

			$.reset(div_3);

			var span = $.sibling(div_3, 2);
			var text_1 = $.only_child(span);

			$.next();
			$.reset(div_2);
			$.next();
			$.reset(div_1);

			var node_1 = $.sibling(div_1, 2);

			{
				var consequent = ($$anchor) => {
					var p = root();
					var text_2 = $.only_child(p, true);

					$.template_effect(() => $.set_text(text_2, $.get(error)));
					$.append($$anchor, p);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.get(error)) $$render(consequent);
					}),
					'if',
					Voice,
					54,
					4
				);
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_2 = root_1();
					var audio = $.sibling($.first_child(fragment_2));
					var button_1 = $.sibling(audio, 2);

					$.next();
					$.template_effect(() => $.set_attribute(audio, 'src', $.get(url)));

					$.delegated('click', button_1, function click_1() {
						return $.set(ready, true);
					});

					$.append($$anchor, fragment_2);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(url) && !$.get(recording)) $$render(consequent_1);
					}),
					'if',
					Voice,
					55,
					4
				);
			}

			$.next();

			$.template_effect(
				($0) => {
					$.set_class(button, 1, $.clsx([
						"size-24 md:size-32 shrink-0 font-display font-semibold text-lg",
						$.get(recording)
							? "bg-ink text-accent animate-pulse"
							: "border-4 border-ink"
					]));

					$.set_text(text, $.get(recording) ? "Stop" : $.get(url) ? "Redo" : "Record");
					styles = $.set_style(div_4, '', styles, { width: `${$.get(seconds) / 60 * 100}%` });
					$.set_text(text_1, `0:${$0 ?? ''} / 1:00`);
				},
				[() => String($.get(seconds)).padStart(2, "0")]
			);

			$.delegated('click', button, function click() {
				return $.get(recording) ? stop() : start();
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_3 = root_3();
			var node_3 = $.sibling($.first_child(fragment_3), 3);

			{
				let $0 = $.derived(() => `Voice note: ${$.get(seconds)} seconds`);

				$.add_svelte_meta(
					() => Booking(node_3, {
						get summary() {
							return $.get($0);
						}
					}),
					'component',
					Voice,
					61,
					4,
					{ componentTag: 'Booking' }
				);
			}

			$.next();
			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(ready)) $$render(consequent_2); else $$render(alternate, -1);
			}),
			'if',
			Voice,
			43,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Voice = $.hmr(Voice);

	import.meta.hot.accept((module) => {
		Voice[$.HMR].update(module.default);
	});
}

export default Voice;

$.delegate(['click']);